import React from 'react';

import AddIcon from '@material-ui/icons/Add';

import { Wrapper } from './styles';
import { Heading } from '../Typography/Heading';

export interface Props {
  text: string;
  handleClick: () => void;
  noMargin?: boolean;
}

const AddButton = ({ text, handleClick, noMargin = false }: Props) => {
  return (
    <Wrapper onClick={handleClick} noMargin={noMargin}>
      <Heading level={5} color="var(--colorUIBlue)" bottom={0}>
        {text}
      </Heading>
      <AddIcon htmlColor="var(--colorUIBlue)" />
    </Wrapper>
  );
};

export default AddButton;
